<template>
    <b-row class="mb-2" align-v="center">
      <b-col :cols="1" class="font-italic font-weight-bold small">
        <span v-if="index">Then</span>
        <span v-else>First</span>
      </b-col>
      <b-col :cols="4">
        <b-form-select
          :value="column"
          @change="v => $emit('change', {column: v})"
          :options="columnOptions"
          :size="inputSize"
          placeholder="Select field"
          required />
      </b-col>

      <b-col :cols="4">
        <b-form-select
          :value="ascending"
          @change="v => $emit('change', {ascending: v})"
          :options="getDirectionOptions"
          :size="inputSize"
          placeholder="Direction"
          required />
      </b-col>

      <b-col :cols="1" class="text-right">
        <i class="fa fa-remove fa-lg text-danger" @click="$emit('delete')"></i>
      </b-col>
    </b-row>
</template>

<script>
  export default {
    name: 'OrderByCondition',

    props: {
      index: Number,
      inputSize: String,
      id: String,

      column: String,
      ascending: Boolean
    },

    computed: {
      columns() {
        return this.$store.getters.customerFileColumns(true);
      },

      columnOptions() {
        return this.columns.map(({slug, name}) => ({value: slug, text: name}));
      },

      getDirectionOptions() {
        return [
          {text: 'ASCENDING', value: true},
          {text: 'DESCENDING', value: false}
        ];
      }
    }
  };
</script>
